export class ResultBox {
  constructor(
    public dirtyPrice: number,

    public cleanPrice: number,

    public modifiedDuration: number,

    public expectedYield: number,

    public expectedYieldBid: number,

    public expectedYieldAsk: number,

    public duration: number,

    public errorMessage: string,

    public errorCode: string,

    public grossYield: number,

    public netYield: number,

    public accruedInterest: number,

    public basisPointValue: number,

    public convexity: number,

    public maturity: number,

    public accruedInterestDays: number,

    public totalAccurateInterest: number,

    public cashflowItem: CashFlowData[],

    public bidPrice: number,

    public askPrice: number,

    public bidPriceTimestamp: Date,

    public defaultConfig: boolean


  ) {
    // fix bad types received from FinanceAPI

    // fix(this,
    //   'dirtyPrice', 'cleanPrice', 'modifiedDuration', 'expectedYield', 'expectedYieldBid', 'expectedYieldAsk', 'duration',
    //   'grossYield', 'netYield', 'accruedInterest', 'basisPointValue',
    //   'convexity', 'maturity', 'accruedInterestDays', 'totalAccurateInterest');

    // if (this.cashflowItem) {
    //   for (const item of this.cashflowItem) {
    //     fix(item, 'cashValue', 'couponFactor', 'presentValue');
    //   }
    // }

    // function fix<T>(instance: T, ...propNames: (keyof T)[]) {
    //   for (const propName of propNames) {
    //     const value = <any> instance[propName];
    //     if (typeof value === 'string') {
    //       instance[propName] = <any> parseFloat(value);
    //     }
    //   }
    // }
  }

}

export class BarChartValue {
  constructor(
    public name: string,

    public y: number,

    public color: string,

    public info: TooltipValue

  ) { }

}

export class TooltipValue {
  constructor(
    public type: string,

    public calc: string,

    public saldo: number,

    public color: string
  ) { }
}

export class CashFlowData {

  constructor(
    public cashValue: number,

    public date: string,

    public couponFactor: number,

    public presentValue: number,

    public timePeriod: string

  ) {

  }
}

export class CashFlowItem {

  constructor(
    public date: Date,

    public title: string,

    public presentValue: number,

    public saldo: number,

    public presentValuePercent: number,

    public saldoPercent: number
  ) { }
}




